import { Base } from '@.api/methods';
import { AuthContextValue } from '@/Services/Auth';

import { DictionaryRequest } from './request';
import { DictionaryResponse } from './response';

export class DictionaryApi extends Base {
    public constructor(auth?: AuthContextValue | null) {
        super(auth, 'v2');
    }

    public dictionaries(request: DictionaryRequest) {
        this.setPath('dictionaries');

        this.setData(request);

        return this.postRequest<DictionaryResponse>();
    }
}
